import { useEffect, useState } from 'react';
import { IStatusOption } from 'interfaces';

import { equipmentApi } from '../api';

export const useEquipmentIvdrOptions = () => {
  const [ivdrOptions, setIvdrOptions] = useState<IStatusOption[]>([]);

  useEffect(() => {
    equipmentApi.getIvdrOptions().then(setIvdrOptions);
  }, []);

  return { ivdrOptions };
};
